import { STATIC_EXPERIMENTS } from './';
import type { ExperimentConfig } from './types';

function getExperiment(pathname: string) {
  return STATIC_EXPERIMENTS.find((config: ExperimentConfig) => {
    return config.paths.includes(pathname);
  });
}

/**
 *The function determines if the test for the pathname is an A/B/C test
 */
export function isMultiVariateExperiment(pathname: string) {
  const experiment = getExperiment(pathname);
  if (!experiment) {
    return false;
  }

  return experiment.isMultiVariate === true;
}

/**
 * The function determines if the test for the pathname is an A/B test
 */
export function isBinaryExperiment(pathname: string) {
  const experiment = getExperiment(pathname);
  if (!experiment) {
    return false;
  }
  return !('isMultiVariate' in experiment) || experiment.isMultiVariate !== true;
}
